<template>
	<div class="text-bluegray-400 text-sm my-3">{{ text }}</div>
</template>

<script lang="ts">
	import { defineComponent } from 'vue'

	export default defineComponent({
		components: {
		},

		props: {
			text: {
				type: String,
				required: true,
			},
		},
	})
</script>

<style scoped>
</style>
